import { render, staticRenderFns } from "./doraemon.vue?vue&type=template&id=18fc351a&scoped=true"
import script from "./doraemon.vue?vue&type=script&lang=js"
export * from "./doraemon.vue?vue&type=script&lang=js"
import style0 from "./doraemon.vue?vue&type=style&index=0&id=18fc351a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc351a",
  null
  
)

export default component.exports